// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1iVGc","content":"ManualTimeModal_content__1uVZF"};